import { render, staticRenderFns } from "./donation-ranking.vue?vue&type=template&id=ed370a9a&scoped=true&"
import script from "./donation-ranking.vue?vue&type=script&lang=js&"
export * from "./donation-ranking.vue?vue&type=script&lang=js&"
import style0 from "./donation-ranking.vue?vue&type=style&index=0&id=ed370a9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed370a9a",
  null
  
)

export default component.exports